/* eslint import/no-cycle: 0 */

import ExperimentsModule from 'client/signup/store/modules/ExperimentsModule';
import FeatureFlagsModule from 'client/signup/store/modules/FeatureFlagsModule';
import Vue from 'vue';
import Vuex from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import signupStoreConfig from 'client/signup/store/signupStoreConfig';

Vue.use(Vuex);

export default new Vuex.Store({
  ...cloneDeep(signupStoreConfig),
  modules: {
    ExperimentsModule,
    FeatureFlagsModule,
  },
});
